import { ServerSchema } from '@common/types';

export const connectionTypeMap: Record<ServerSchema['connectionType'], string> = {
  ssh: 'SSH',
  php: 'PHP',
  'persistent-ssh': '(p)SSH',
  listen: 'Listener',
};
